import React from "react";

import DocumentItems from "../../DocumentItems";

// eslint-disable-next-line react/prefer-stateless-function
class ComponentView extends React.Component {
  render() {
    return (
      <DocumentItems
        itemType={this.props.itemType}
        blockType={this.props.blockType}
        key={this.props.id}
        mode={this.props.mode}
        componentMeta={this.props.componentMeta}
        component={this.props.component}
        layout={this.props.layout}
        rowIndex={this.props.rowIndex}
        colIndex={this.props.colIndex}
        position={this.props.position}
        isLocked={this.props.isLocked}
        sectionID={this.props.sectionID}
        isSharedDocument={this.props.isSharedDocument}
        isDocumentLocked={this.props.isDocumentLocked}
        draggedSection={this.props.draggedSection}
        setDraggedSection={this.props.setDraggedSection}
        addComponent={this.props.addComponent}
        cloneSection={this.props.cloneSection}
        totalRowItems={this.props.totalRowItems}
        updateComponent={this.props.updateComponent}
        deleteComponent={this.props.deleteComponent}
        removeHighlightSelection={this.props.removeHighlightSelection}
        updateHoveredSectionId={this.props.updateHoveredSectionId}
        removeActiveComponents={this.props.removeActiveComponents}
        showDocumentDiffView={this.props.showDocumentDiffView}
        disablePlusBtnHandler={this.props.disablePlusBtnHandler}
        // Refs related props
        customToolbarRef={this.props.customToolbarRef}
        signatureWrapperRef={this.props.signatureWrapperRef}
        hoveredActiveComponentId={this.props.hoveredActiveComponentId}
        setRefsByType={this.props.setRefsByType}
        // Template related props
        handleComponentLockUnlock={this.props.handleComponentLockUnlock}
        tableColorpickerDropdownRef={this.props.tableColorpickerDropdownRef}
        openTableColorpicker={this.props.openTableColorpicker}
        closeTableColorpicker={this.props.closeTableColorpicker}
        match={this.props.match}
      />
    );
  }
}

export default ComponentView;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/ComponentView/ComponentView.js